import { search } from '../searchService';
import { post, put, del, getById } from '../apiService';
import type { Certificate } from '../../types/content/certificate';
import type { SearchParams } from '../../types/search';

export async function searchCertificates(
  filter: object = {},
  params: SearchParams = {},
): Promise<Certificate[]> {
  return search<Certificate>('/certificate/search', filter, params);
}

export async function getCertificateById(id: string): Promise<Certificate> {
  return getById<Certificate>('/certificate', id);
}

export async function createCertificate(data: Partial<Certificate>): Promise<Certificate> {
  return post<Certificate>('/certificate', data);
}

export async function updateCertificate(id: string, data: Certificate): Promise<Certificate> {
  return put<Certificate>(`/certificate/${id}`, data);
}

export async function deleteCertificate(id: string): Promise<void> {
  return del<void>(`/certificate/${id}`);
}
